module.exports = __webpack_public_path__ + "media/images/pic/anime/mountain-f8624e77410cf49924eefce3be5956c6.svg";